import { useEffect, useRef, useState } from "react"
import SidePanel from "../side-panel"
import {
  clearImagePreview,
  imagePreview
} from "../../../redux/slices/conversations"
import { useSelector } from "react-redux"
import { useAppDispatch } from "../../hooks"

const ImagePreviewPanel = () => {
  const dispatch = useAppDispatch()
  const imagePreviewURL = useSelector(imagePreview)

  const onClose = () => dispatch(clearImagePreview())

  const [imagePreviewURLLocal, setImagePreviewURL] = useState<
    string | undefined
  >(imagePreviewURL)

  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (imagePreviewURL) {
      setImagePreviewURL(imagePreviewURL)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    } else {
      timeoutRef.current = setTimeout(() => {
        setImagePreviewURL(undefined)
      }, 2500)
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [imagePreviewURL])

  return (
    <SidePanel open={!!imagePreviewURL} title="Rate quote" onClose={onClose}>
      {imagePreviewURLLocal ? (
        <a href={imagePreviewURLLocal} target="_blank" rel="noreferrer">
          <img
            className="max-w-full cursor-pointer"
            src={imagePreviewURLLocal}
            alt="rate quote"
          />
        </a>
      ) : null}
    </SidePanel>
  )
}

export default ImagePreviewPanel
